export const formatPrice = (
  price: number,
  options?: Intl.NumberFormatOptions
) => {
  if (isNaN(price)) {
    return '';
  }

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    ...options,
  })
    .format(price)
    .replace(' ', ' ');
};
